import { useEffect, useState } from 'react';

/**
 * Hook that cycles through a list of placeholder strings at regular intervals.
 *
 * @param placeholders - Array of placeholder strings to cycle through
 * @returns The current placeholder string
 *
 * This hook:
 * 1. Initializes with the first placeholder in the array
 * 2. Every 5 seconds, randomly selects a new placeholder that's different from the current one
 * 3. Returns the current placeholder for use in the component
 */
export function usePlaceholders(placeholders: string[]) {
  const [placeholder, setPlaceholder] = useState(placeholders[0]);
  useEffect(() => {
    const updatePlaceholder = () => {
      let randomIndex = undefined;
      do {
        randomIndex = Math.floor(Math.random() * placeholders.length);
      } while (placeholders[randomIndex] === placeholder);
      setPlaceholder(placeholders[randomIndex]);
    };

    setTimeout(updatePlaceholder, 5000);
  }, [placeholder]);

  return placeholder;
}
